import { createTheme } from "@mui/material/styles";
import { getLanguageSetting } from "../localSettings/utils";
import * as datePickerLocales from "@mui/x-date-pickers/locales";
import * as coreLocales from "@mui/material/locale";
import * as dataGridLocales from "@mui/x-data-grid-pro";
import { PaletteColor, PaletteColorOptions } from "@mui/material";

declare module "@mui/material/styles" {
	interface Palette {
		yellow: PaletteColor;
	}

	interface PaletteOptions {
		yellow?: PaletteColorOptions;
	}
}

const userLang = getLanguageSetting();
const themeInitial = createTheme(
	{
		palette: {
			primary: {
				main: localStorage.getItem("theme.palette.primary.main") ?? "#2fa4e7",
				contrastText: "#ffffff",
			},
			secondary: {
				main: localStorage.getItem("theme.palette.secondary.main") ?? "#868e96",
			},
			error: {
				main: localStorage.getItem("theme.palette.error.main") ?? "#b90505",
			},
			warning: {
				main: localStorage.getItem("theme.palette.warning.main") ?? "#ffa726",
			},
			success: {
				main: localStorage.getItem("theme.palette.success.main") ?? "#4caf50",
			},
			info: {
				main: localStorage.getItem("theme.palette.info.main") ?? "#2196f3",
			},
		},
		typography: {
			fontFamily: [
				"-apple-system",
				"BlinkMacSystemFont",
				'"Segoe UI"',
				"Roboto",
				'"Helvetica Neue"',
				"Arial",
				'"Noto Sans"',
				'"Liberation Sans"',
				"sans-serif",
				'"Apple Color Emoji"',
				'"Segoe UI Emoji"',
				'"Segoe UI Symbol"',
				'"Noto Color Emoji"',
			].join(","),
		},
		components: {
			MuiListItemIcon: {
				styleOverrides: {
					root: {
						minWidth: "30px !important",
					},
				},
			}
		},
	},
	// Localizations
	{
		en: coreLocales.enUS,
		fi: coreLocales.fiFI,
	}[userLang],
	{
		en: dataGridLocales.enUS,
		fi: dataGridLocales.fiFI,
	}[userLang],
	{
		en: datePickerLocales.enUS,
		fi: datePickerLocales.fiFI,
	}[userLang],
);

export const AAVO_MUI_THEME = createTheme(themeInitial, {
	palette: {
		yellow: themeInitial.palette.augmentColor({
			color: {
				main: "#f5b800",
			},
			name: "yellow",
		}),
	},
});
